import { Component, VNode, h } from '@stencil/core';

/**
 * @tag `<ads-card-label>`
 * @hidden
 */
@Component({
  tag: 'ads-card-label',
  styleUrl: 'ads-card-label.scss',
  shadow: true,
})
export class AdsCardLabel {
  protected render(): VNode {
    return (
      <span class="c-card-label">
        <span class="c-card-label__text">
          <slot />
        </span>
        <span class="c-card-label__border"></span>
      </span>
    ) as VNode;
  }
}
